import * as keyapis_vc_v1_camera_pb from "./v1/keyapis_vc_camera_v1.pb";
import * as keyapis_vc_v1_camera_access_pb from "./v1/keyapis_vc_camera_access_v1.pb";
import * as keyapis_vc_v1_camera_group_pb from "./v1/keyapis_vc_camera_group_v1.pb";
import * as keyapis_vc_v1_camera_location_data_pb from "./v1/keyapis_vc_camera_location_data_v1.pb";
import * as keyapis_vc_v1_camera_video_data_pb from "./v1/keyapis_vc_camera_video_data_v1.pb";
import * as keyapis_vc_v1_company_pb from "./v1/keyapis_vc_company_v1.pb";
import * as keyapis_vc_v1_events_pb from "./v1/keyapis_vc_events_v1.pb";

export default {
  v1: {
    resources: {
      camera: keyapis_vc_v1_camera_pb,
      cameraAccess: keyapis_vc_v1_camera_access_pb,
      cameraGroup: keyapis_vc_v1_camera_group_pb,
      cameraLocationData: keyapis_vc_v1_camera_location_data_pb,
      cameraVideoData: keyapis_vc_v1_camera_video_data_pb,
      company: keyapis_vc_v1_company_pb,
      events: keyapis_vc_v1_events_pb,
    },
  },
};
